export function getCookieDomain(): string {
  const parts = window.location.hostname.split('.');
  const lastTwo = parts.slice(-2).join('.');
  const isCompoundBr = /^(com|net|org|gov|edu)\.br$/.test(lastTwo);
  const apex = (isCompoundBr ? parts.slice(-3) : parts.slice(-2)).join('.');
  return '.' + apex;
}

export function getCookie(name: string): string | undefined {
  const all = document.cookie ? document.cookie.split('; ') : [];
  for (const entry of all) {
    const eq = entry.indexOf('=');
    if (eq < 0) continue;
    if (entry.slice(0, eq) === name) {
      const raw = entry.slice(eq + 1);
      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    }
  }
  return undefined;
}

export function setCookie(name: string, value: string, ttlDays: number): void {
  if (!value) return;
  const exp = new Date(Date.now() + ttlDays * 86400000).toUTCString();
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie =
    `${name}=${encodeURIComponent(value)}; ` +
    `expires=${exp}; ` +
    `domain=${getCookieDomain()}; ` +
    `path=/; SameSite=Lax${secure}`;
}
